import React from "react";
import {
  delete_opportunity,
  get_opportunities,
} from "../../../services/apis/opportunity";
import { useAppDispatch, useAppSelector } from "../../../store";
import DataTable from "../../../component/element/table";
import { ColumnDef } from "@tanstack/react-table";
import {
  IOpportunity,
  IOpportunityTypes,
} from "../../../store/types/opportunity";
// import EditOportunity from "./EditOportunity";
import ItemAction from "../../../component/ui/action/ItemAction";
import { useNavigate } from "react-router-dom";
//icons
import { FaComputer, FaPersonWalking } from "react-icons/fa6";

const OpportunityTable = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const opportuities = useAppSelector(
    ({ opportunity }) => opportunity.opportunities,
  );

  const loadingOpportunityId = useAppSelector(
    ({ opportunity }) => opportunity.loadingOpportunityId,
  );
  const onLoad = React.useCallback(() => {
    get_opportunities(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const columns: ColumnDef<IOpportunity>[] = [
    {
      accessorKey: "opportunity_image",
      header: "Image",
      cell: ({ getValue }) => {
        const image = getValue() as string;
        return (
          <img
            loading="lazy"
            src={image}
            alt={image}
            className="w-11 h-auto object-cover rounded-lg"
          />
        );
      },
    },
    {
      accessorKey: "opportunity_name",
      header: "Name",
      cell: ({ getValue }) => {
        const name = getValue() as string;
        return <span className="capitalize">{name}</span>;
      },
    },
    {
      accessorKey: "type",
      header: "Type",
      cell: ({ getValue }) => {
        const type = getValue() as IOpportunityTypes;

        // Define background colors for different types
        const bgColors = {
          physical: "bg-blue-50 text-blue-800", // Soft Blue for Physical
          online: "bg-yellow-50 text-yellow-800", // Soft Green for Online
        };

        return (
          <span className={`rounded-md flex items-center`}>
            {type?.name && (
              <div
                className={`flex items-center gap-2 text-xs font-medium px-2 py-1 rounded-full capitalize ${bgColors[type.name as keyof typeof bgColors]}`}
              >
                <span>
                  {type.name === "physical" ? (
                    <FaPersonWalking />
                  ) : (
                    <FaComputer />
                  )}
                </span>
                <span>{type.name}</span>
              </div>
            )}
          </span>
        );
      },
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ getValue }) => {
        const status = getValue() as string;
        return (
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${status === "1" ? "bg-primary-100/50 text-primary-500" : "bg-red-50 text-red-800"}`}
          >
            {status === "1" ? "active" : "not active"}
          </span>
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ getValue }) => {
        const id = getValue() as string;
        return (
          <ItemAction
            delete_loading={loadingOpportunityId === id}
            show_edit={false}
            onEdit={() => null}
            onView={() => navigate(`/opportunity/${id}`)}
            onDelete={() => delete_opportunity(id, dispatch)}
          />
        );
      },
    },
  ];

  return (
    <>
      <DataTable columns={columns} data={opportuities} />
      {/* <EditOportunity
          show={edit.show}
          opportunity={edit.data}
          onHandler={() => editSet({ show: false, data: null })}
        /> */}
    </>
  );
};

export default OpportunityTable;
